import CampaignPage from "./CampaignContainer";

export default CampaignPage;
